import { useEffect } from "react";
import styled from "styled-components";
import { useMap } from "react-leaflet";
import L from "leaflet";

export const MapBoundsFitter = ({ geoJsonData, animate = false }) => {
  const map = useMap();

  useEffect(() => {
    if (
      geoJsonData &&
      geoJsonData.features &&
      geoJsonData.features.length > 0
    ) {
      // Create a temporary layer to calculate bounds
      const tempLayer = L.geoJSON(geoJsonData);
      const bounds = tempLayer.getBounds();

      if (bounds.isValid()) {
        // Fit the map to the bounds with some padding
        map.fitBounds(bounds, {
          padding: [20, 20], // Padding in pixels [top/bottom, left/right]
          maxZoom: 8, // Maximum zoom level
          minZoom: 5, // Minimum zoom level
          animate: animate
        });
      } else {
        console.log("Invalid bounds calculated");
      }
    }
  }, [geoJsonData, map, animate]);

  return null;
};

export const MapWrapper = styled.div`
  height: ${(props) => props.height || "100%"};
  min-height: ${(props) => props.$minHeight || "24rem"};
  width: 100%;
  border: ${(props) =>
    props.$noBorder ? "none" : "2px solid rgba(0, 0, 0, 0.1)"};
  box-shadow: ${(props) =>
    props.$noShadow ? "none" : "inset 0 2px 4px rgba(0, 0, 0, 0.1)"};
  border-radius: 1rem;
  overflow: hidden;
  position: relative;
  z-index: 1;

  /* Ensure Leaflet map container styles are applied */
  .leaflet-container {
    height: 100% !important;
    width: 100% !important;
  }

  .leaflet-control-zoom {
    display: none !important;
  }

  .leaflet-control-attribution {
    display: none !important;
  }
`;
